import { useCallback, useEffect } from 'react'
import { useLogEvent } from './useLogEvent'
import { MINUTES } from '@sequencehq/utils/dates'

const MEMORY_LOGGING_INTERVAL = 10 * MINUTES // Log memory usage every 10 minutes
export const useLogMemoryUsage = () => {
  const { logEvent } = useLogEvent()

  const logMemoryUsage = useCallback(() => {
    try {
      if (performance && 'memory' in performance) {
        const memoryUsage = performance.memory as {
          usedJSHeapSize: number
          totalJSHeapSize: number
          jsHeapSizeLimit: number
        }

        logEvent({
          eventName: 'memory_usage',
          metadata: {
            usedJSHeapSize: memoryUsage.usedJSHeapSize,
            totalJSHeapSize: memoryUsage.totalJSHeapSize,
            jsHeapSizeLimit: memoryUsage.jsHeapSizeLimit
          }
        })
      }
    } catch {
      // Ignore errors in case performance.memory is not accessible
    }
  }, [logEvent])

  useEffect(() => {
    const interval = setInterval(() => {
      logMemoryUsage()
    }, MEMORY_LOGGING_INTERVAL)

    return () => clearInterval(interval)
  }, [logMemoryUsage])
}
